var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.35442 21.1641C10.0596 21.7864 10.9858 22.1641 12.0002 22.1641C13.0147 22.1641 13.9409 21.7864 14.6461 21.1641M2.29414 5.98395C2.27979 4.53261 3.06227 3.17731 4.32635 2.46406M21.7024 5.98396C21.7167 4.53261 20.9342 3.17731 19.6702 2.46407M18.0002 8.16406C18.0002 6.57276 17.3681 5.04664 16.2429 3.92142C15.1177 2.7962 13.5915 2.16406 12.0002 2.16406C10.4089 2.16406 8.88283 2.7962 7.75761 3.92142C6.63239 5.04664 6.00025 6.57276 6.00025 8.16406C6.00025 11.2542 5.22072 13.37 4.34991 14.7695C3.61538 15.9499 3.24811 16.5402 3.26157 16.7048C3.27649 16.8871 3.31511 16.9567 3.46203 17.0656C3.59471 17.1641 4.19284 17.1641 5.3891 17.1641H18.6114C19.8077 17.1641 20.4058 17.1641 20.5385 17.0656C20.6854 16.9567 20.724 16.8871 20.7389 16.7048C20.7524 16.5402 20.3851 15.9499 19.6506 14.7695C18.7798 13.37 18.0002 11.2542 18.0002 8.16406Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/NotificationsIcon.cf2f12c5c13f8a4a45e08f5c69321919.svg";
export { ForwardRef as ReactComponent };